import GamePlay from "@/pages/GamePlay/Index";
import GameSelect from "@/pages/GameSelect/Index";
import Home from "@/pages/Home/Index";
import Upload from "@/pages/Upload/Index";
import Rank from "@/pages/Rank/Index";
import { Routes, Route } from "react-router-dom";
import Footer from "@/components/Footer/Index";

const Routing = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/u" element={<Upload />} />
        <Route path="/game/:name" element={<GameSelect />} />
        <Route path="/game/:name/:select" element={<GamePlay />} />
        <Route path="/rank/:name" element={<Rank />} />
      </Routes>
      <Footer />
    </>
  );
};

export default Routing;
